import { createContext, useContext } from 'react';

const DrawerContext = createContext(false);

export const useDrawerContext = () => useContext(DrawerContext);

export const DrawerContextProvider = DrawerContext.Provider;
